import React from 'react';
import logoImage from '../assets/logo.png';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  textColor?: 'light' | 'dark';
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  showText = false, 
  className = '',
  textColor = 'light'
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
  };

  const textColorClasses = {
    light: 'text-white',
    dark: 'text-gray-800'
  };

  const subtextColorClasses = {
    light: 'text-green-200',
    dark: 'text-green-600'
  };

  const borderColorClasses = {
    light: 'border-white/20',
    dark: 'border-green-200'
  };

  return (
    <div className={`flex items-center justify-center space-x-3 ${className}`}>
      <div className={`${sizeClasses[size]} rounded-full overflow-hidden border-2 ${borderColorClasses[textColor]} shadow-lg flex-shrink-0`}>
        <img 
          src={logoImage} 
          alt="Yakjeti Pakistan Logo" 
          className="w-full h-full object-cover"
        />
      </div>
      {showText && (
        <div className="text-center">
          <h1 className={`${textSizeClasses[size]} font-bold ${textColorClasses[textColor]} leading-tight`}>
            Yakjeti Pakistan
          </h1>
          <p className={`text-xs ${subtextColorClasses[textColor]} leading-none`}>
            Welfare Society
          </p>
        </div>
      )}
    </div>
  );
};

export default Logo;
